import type { SVGProps } from 'react';
const SvgExposureNeg1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#exposure_neg_1_svg__a)">
      <path
        fill="currentColor"
        d="M4 11v2h8v-2H4Zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13Z"
      />
    </g>
    <defs>
      <clipPath id="exposure_neg_1_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgExposureNeg1;
